/**
 * Recomaze/Cookiebot/Carthike set inline z-index: 2147483647 !important.
 * Stylesheets cannot win against that — this overwrites the inline value while
 * drawers, menus, popups or the sticky ATC panel are in the way.
 */
(() => {
  const widgetSelector = [
    'recomaze-ai-host',
    'recomaze-ai-root',
    '#CookiebotWidget',
    '#carthike-chat-wrapper',
    '#carthike-chat-button-container',
  ].join(',');

  const overlaySelector = [
    '.js-overlay.is-visible',
    '.drawer[open]',
    '.main-menu__disclosure.is-open',
    '.modal[open]',
  ].join(', ');

  const isOverlayOpen = () => {
    return (
      document.body.classList.contains('fixed') ||
      document.body.classList.contains('overflow-hidden') ||
      document.body.classList.contains('overlay-predictive-search') ||
      Boolean(document.querySelector(overlaySelector))
    );
  };

  const isStickyAtcVisible = () => {
    const panel = document.querySelector('sticky-atc-panel.sticky-atc-panel');

    if (!panel) return false;

    return !panel.classList.contains('sticky-atc-panel--out') && !document.body.classList.contains('scrolled-to-bottom');
  };

  const sync = () => {
    const hide = isOverlayOpen() || isStickyAtcVisible();

    document.querySelectorAll(widgetSelector).forEach((el) => {
      const isRecomaze = el.matches('recomaze-ai-host, recomaze-ai-root');

      if (hide) {
        if (isRecomaze) {
          el.style.setProperty('display', 'none', 'important');
        }

        el.style.setProperty('z-index', '1', 'important');

        return;
      }

      if (isRecomaze) {
        el.style.removeProperty('display');
      }

      el.style.removeProperty('z-index');
    });
  };

  const observeTarget = (el) => {
    if (!el) return;

    observer.observe(el, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
  };

  const observer = new MutationObserver((mutations) => {
    const addedWidgets = mutations.some((mutation) =>
      [...mutation.addedNodes].some(
        (node) => node.nodeType === 1 && (node.matches?.(widgetSelector) || node.querySelector?.(widgetSelector))
      )
    );

    if (addedWidgets) {
      document
        .querySelectorAll('.js-overlay, .drawer, modal-dialog, .main-menu__disclosure, predictive-search, sticky-atc-panel')
        .forEach(observeTarget);
    }

    sync();
  });

  const start = () => {
    observer.observe(document.documentElement, { childList: true });
    observer.observe(document.body, { childList: true, attributes: true, attributeFilter: ['class'] });
    document
      .querySelectorAll('.js-overlay, .drawer, modal-dialog, .main-menu__disclosure, predictive-search, sticky-atc-panel')
      .forEach(observeTarget);
    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  ['on:cart-drawer:before-open', 'on:cart-drawer:after-close', 'on:quickbuy:before-open', 'on:quickbuy:after-close'].forEach(
    (eventName) => {
      document.addEventListener(eventName, sync);
    }
  );
})();
